'use client';

import { RoundButton } from '@/components/buttons/Buttons';
import '@/components/program/travel-customization.styles.css';
import { TRAVEL_PROGRAM_FORM } from '@/constants/forms';
import { rideOptions } from '@/constants/travel-program';
import type { Ride } from '@/types';
import { difference } from 'lodash';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { classNames } from 'primereact/utils';
import { useFormContext } from 'react-hook-form';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import CheckboxGroupInput from '../form-inputs/CheckboxGroupInput';

const RideItem = () => {
	const { control, setValue, watch } = useFormContext();
	const ridesValue = watch('rides');

	const toggleRideSelection = (rideName: string) => {
		const temporaryRides: string[] = [...ridesValue];

		if (temporaryRides.includes(rideName)) {
			setValue(
				'rides',
				temporaryRides.filter((ride: string) => ride !== rideName),
			);
		} else {
			setValue('rides', [...temporaryRides, rideName]);
		}
	};

	const isAllSelected = (rides: Ride[]) => {
		const rideValues = rides.map((ride) => ride.value);

		return difference(rideValues, ridesValue).length === 0;
	};

	const selectAllCategory = (rides: Ride[]) => {
		const rideValues = rides.map((ride) => ride.value);

		if (rideValues.length > ridesValue.length) {
			const temporaryRides = [...ridesValue, ...rideValues];
			setValue('rides', temporaryRides);
		} else {
			console.log('Else ran');
			setValue('rides', []);
		}
	};

	return (
		<Accordion
			activeIndex={[0]}
			expandIcon={<FaChevronRight className=" text-gray-600" />}
			collapseIcon={<FaChevronDown className=" text-gray-600" />}
			multiple
		>
			{rideOptions.map((category) => (
				<AccordionTab
					pt={{
						headerIcon: {
							className: classNames('tc-accordion-header-icon'),
						},
						root: {
							className: classNames('tc-accordion'),
						},
						headerAction: {
							className: classNames('tc-accordion-content '),
						},
						content: {
							className: classNames('tc-accordion-content '),
						},
					}}
					key={category.category}
					header={
						<div className="flex justify-between items-center w-full">
							<div className="ml-5">
								<span className="text-body-large text-onSurface">
									{category.category}
								</span>
								{isAllSelected(category.rides) && (
									<span className="ml-2 text-xs">
										All selected
									</span>
								)}
							</div>
							<RoundButton
								id="select-all"
								label="Select All"
								className="tc-text-button tc-accordion-select-all"
								onClick={(e) => {
									e.stopPropagation();
									selectAllCategory(category.rides);
								}}
							/>
						</div>
					}
				>
					{category.rides.length > 0 ? (
						category.rides.map((ride) => (
							<div
								key={ride.name}
								className="flex items-center justify-between py-1.5 border-b border-gray-300"
							>
								<div className="flex items-center gap-3">
									<img
										src={ride.icon}
										alt="icon"
										width={40}
										height={40}
									/>
									<div>
										<p className="text-body-large text-lg text-onSurface">
											{ride.name}
										</p>
										<p className="text-body-small text-[#49454F]">
											{ride.description}
										</p>
									</div>
								</div>
								<CheckboxGroupInput
									checked={ridesValue.includes(ride.value)}
									className="mx-10"
									control={control}
									formName={TRAVEL_PROGRAM_FORM}
									id="rides"
									onChange={() =>
										toggleRideSelection(ride.value)
									}
									pt={{
										root: {
											className: 'hover:bg-transparent',
										},
										box: {
											className: classNames(
												'tc-checkbox-input',
												{
													'tc-checkbox-input-checked':
														!!ridesValue.includes(
															ride.value,
														),
												},
											),
										},
										icon: {
											className: 'tc-checkbox-icon',
										},
									}}
									showError={false}
								/>
							</div>
						))
					) : (
						<p className="text-gray-500">No available rides</p>
					)}
				</AccordionTab>
			))}
		</Accordion>
	);
};

export default RideItem;
